module.exports = __webpack_public_path__ + "static/media/avril-lavigne-icon.047269c5.jpg";